import { render } from "./ModalAddress.vue?vue&type=template&id=aad35f80&scoped=true"
import script from "./ModalAddress.vue?vue&type=script&lang=js"
export * from "./ModalAddress.vue?vue&type=script&lang=js"

import "./ModalAddress.vue?vue&type=style&index=0&id=aad35f80&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad35f80"]])

export default __exports__